import React from 'react';
import moment from 'moment';
import toast from 'react-hot-toast';
import { classNames, Constants } from '../../../utils';
import { BeneficiariesIcon, OwnerIcon } from '../../../assets/icons';
import { PurchasesService, GeneralService } from '../../../services';

class ProductHistory extends React.Component {

  state = {
    form: {
      level_id: Constants.LEVELS.OWNER,
      since: '',
      until: '',
      page: 1,
      pages: 1,
    },
    isLoading: false,
    products: [],
  }

  componentDidMount() {
    this.getProducts();
  }

  getProducts = async (page = 1) => {
    const { form } = this.state;
    await this.setState({ isLoading: true });

    try {
      const data = {
        ...form,
        since: form.since ? moment(form.since).format('YYYY-MM-DD') : '',
        until: form.until ? moment(form.until).format('YYYY-MM-DD') : '',
      };

      const res = await PurchasesService.getPurchasesProducts(data);

      this.setState({
        products: page > 1 ? [ ...this.state.products, ...res.data ] : res.data,
        form: {
          ...form,
          pages: res.pages,
          page,
        },
        isLoading: false,
      });

    } catch (error) {
      console.log(error);
      toast.error('Ocurrió un error inesperado');
    }

    this.setState({ isLoading: false });
  }

  change = async (value,target) => {
    await this.setState(s => ({
      form: { ...s.form, [target]: value },
      products: [],
    }));

    this.getProducts();
  }

  downloadRCV = async (item) => {
    console.log(item);
    await this.setState({ isLoading: true });

    // Si ya existe el idepol, solo se obtiene el reporte.
    if (item.idepol !== null) {
      const reportOpened = await this.handleReport(item.idepol);
      this.setState({ isLoading: false });
      if (!reportOpened) return;
      return;
    }

    try {
      const data = {
        client: item.user.id,
        route: 'emitirAuto',
        codprod: 'RCVD',
        codplan: '005',
        revplan: '001',
        tipoid: 'V',
        numid: item.user.dni, // CÉDULA
        dvid: 0,
        nomter: item.user.name || '', // NOMBRES
        apeter: item.user.last_name || '', // APELLIDOS
        fecnac: moment(item.user.birthdate).format('DD-MM-YYYY'), // Fecha de nacimiento (dd-mm-yyyy)
        sexo: item.user.gender_id === Constants.GENDER.MALE ? 'M' : 'F', // SEXO: M/F
        email: item.user.email, // EMAIL
        telofi: item.user.phone || '', // Tlf contacto
        codpais: '001',
        codestado: '', // Consultar en Backend
        codciudad: '', // Consultar en Backend
        codmunicipio: '', // Consultar en Backend
        codparroquia: '',
        codsect: '',
        direccion: item.user.address || '',
        marca: item.purchase.purchase_req_docs[0].vehicle_data.brand, // Consultar en Backend 
        modelo: item.purchase.purchase_req_docs[0].vehicle_data.model, // Consultar en Backend
        version: '',
        claseVehiculos: '000002',
        anmoveh: item.purchase.purchase_req_docs[0].vehicle_data.year, // Año del vehículo
        placa: item.purchase.purchase_req_docs[0].vehicle_data.plate, // Placa
        serialCarroceria: item.purchase.purchase_req_docs[0].vehicle_data.serial, // Serial carrocería
        serialMotor: item.purchase.purchase_req_docs[0].vehicle_data.engine_serial, // Serial motor
        clase: '',
        color: item.purchase.purchase_req_docs[0].vehicle_data.color || 'BLANCO', // Color
        kilometraje: item.purchase.purchase_req_docs[0].vehicle_data.mileage, // Kilometraje
        indnuevo: 'N', // Indicador si es nuevo el vehículo (N)
        fechaAdq: "10/06/2022", // Fecha de adquisición (dd/mm/yyyy)
        tipocar: '',
        tipodes: '',
        zipecode: '2101',
        peso : item.purchase.purchase_req_docs[0].vehicle_data.weight || '450', //Peso del vehiculo 
        coddestinado: "P", //Destino del Vehículo P (particular), C (carga)
      };

      // 2. Emitir póliza
      const emissionResponse = await GeneralService.acxelCallApi(data);
      console.log(emissionResponse);

      // 3. Validar respuesta de emisión
      if (
        !emissionResponse?.idepol ||
        isNaN(emissionResponse.idepol) ||
        Number(emissionResponse.idepol) <= 0
      ) {
        this.setState({ isLoading: false });
        if(emissionResponse?.desc_resp)
          return toast.error(emissionResponse?.desc_resp);
        return toast.error('No se pudo obtener el ID de la póliza');
      }

      // >>> NUEVO: Guardar idepol en backend <<<
      try {
        await GeneralService.saveIdepol({
          purchase_product_id: item.id,     // ID del purchase_product
          idepol: emissionResponse.idepol,   // ID de póliza generado por ACXEL
        });
      } catch (error) {
        console.error('Error guardando idepol:', error);
        toast.error('Error al guardar el número de póliza');
        throw error;
      }

      // 4. Obtener y abrir URL del reporte
      const reportOpened = await this.handleReport(emissionResponse.idepol);
      this.setState({ isLoading: false });
      if (!reportOpened) return;
    } catch (error) {
      console.error(error);
      toast.error('Ocurrió un error inesperado');
      this.setState({ isLoading: false });
    }
  };

  // Función auxiliar para obtener el reporte a partir de un idepol y validarlo.
  handleReport = async (idepol) => {
    const pdfRequestData = {
      route: 'reportes/polizas',
      idepol,
    };

    const pdfResponse = await GeneralService.acxelCallApi(pdfRequestData);
    console.log(pdfResponse);
    return this.openPdfReport(pdfResponse);
  };

  // Función auxiliar para validar y abrir la URL del reporte PDF.
  openPdfReport = (pdfResponse) => {
    if (pdfResponse?.URL_REPORT) {
      const reportWindow = window.open(pdfResponse.URL_REPORT, '_blank');
      if (!reportWindow || reportWindow.closed || typeof reportWindow.closed === 'undefined') {
        toast.error('El navegador bloqueó la apertura del reporte. Por favor habilite los pop-ups para este sitio.');
        return false;
      }
      return true;
    } else {
      toast.error('No se recibió una URL válida para el reporte');
      return false;
    }
  };


  render() {

    const { form, isLoading, products } = this.state;

    return (
      <div className="mt-8 lg:mt-0">
        <div className="bg-darkBlue -mt-4 -mx-4 pt-2 pb-4">
          <div className="bg-darkBlue mx-auto flex justify-center items-center gap-4">
            <TabButton
              icon={OwnerIcon}
              label="Titular"
              isActive={form.level_id === Constants.LEVELS.OWNER}
              onClick={() => this.change(Constants.LEVELS.OWNER, 'level_id')}
            />

            <TabButton
              icon={BeneficiariesIcon}
              label="Beneficiario"
              isActive={form.level_id === Constants.LEVELS.BENEFICIARY}
              onClick={() => this.change(Constants.LEVELS.BENEFICIARY, 'level_id')}
            />
          </div>
        </div>

        <div className="max-w-[800px] mx-auto pt-6 grid grid-cols-2 gap-4">
          {products.map((item, index) => (
            <RequestItem
              key={index}
              item={item}
              isBeneficiary={form.level_id === Constants.LEVELS.BENEFICIARY}
              downloadRCV={() => this.downloadRCV(item)} //Para descargar la poliza RCV
            />
          ))}
        </div>

        {(isLoading && form.page < form.pages) && (
          <div className="flex justify-center mt-2">
            <button
              className="ml-0 bg-green px-4 py-1 rounded-full font-semibold text-white"
              onClick={() => this.getProducts(form.page + 1)}
            >
              <span>Cargar más</span>
            </button>
          </div>
        )}

        {(!isLoading && !products.length) && (
          <p className="font-semibold text-gray3 text-center my-10">
            No hay productos
          </p>
        )}
      </div>
    );
  }
}

const TabButton = ({ icon, label, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={classNames(
      'w-40 flex justify-center items-center rounded-lg p-2 gap-3',
      isActive ? 'bg-green' : 'bg-gray5'
    )}
  >
    <img
      src={icon}
      className={classNames('w-5 h-5 object-contain brightness-0', isActive ? 'invert' : '')}
      alt=""
    />
    <span className={classNames('flex-1 font-semibold text-left', isActive ? 'text-white' : 'text-darkBlue')}>
      { label }
    </span>
  </button>
);

const RequestItem = ({ item, isBeneficiary = false, downloadRCV }) => {
  const number = String(item.id).padStart(4,'0');
  const createdAt = moment(item.created_at).format('DD-MM-YYYY');
  const expiredAt = moment(item.expired_at).format('DD-MM-YYYY');

  return (
    <div className="bg-white rounded-lg border border-gray6 p-2 text-sm">
      <div className="flex justify-between items-center">
        <p className="font-bold text-darkBlue">N° { number } / { createdAt }</p>
        {item?.status === Constants.PURCHASE.STATUS.NULLED && (
          <span className="text-red">{ item?.status_text }</span>
        )}
      </div>
      <p>
        <span className="font-semibold">Tipo de Producto: </span>
        <span>{ item.product?.name }</span>
      </p>
      {isBeneficiary && (
        <p>
          <span className="font-semibold">Beneficiario: </span>
          <span>{ item.user?.fullName }</span>
        </p>
      )}
      <p>
        <span className="font-semibold">Fecha de vencimiento: </span>
        <span>{ expiredAt }</span>
      </p>

      {/* Nuevo enlace de descarga de poliza RCV */}
      {
        item.product?.is_rcv === 1 &&
        item.purchase?.purchase_req_docs?.[0]?.vehicle_data && (
          <div className="text-right mt-2">
            <button
              onClick={() => downloadRCV()} // Ya lleva el item implícito
              className="text-blue-600 hover:text-blue-800 underline bg-transparent border-none cursor-pointer p-0"
            >
              Descargar póliza
            </button>
          </div>
        )
      }
    </div>
  );
};

export default ProductHistory;
